import { ReactNode } from 'react'
import styled from 'styled-components'

import typeStyle from '../../styles/typeStyle'
import WarningCard from '../../components/cards/WarningCard'
import YogaDetailedIcon from '../../components/icons/YogaDetailed'

const IllustrationWrapper = styled.div`
  margin-bottom: 24px;

  svg {
    margin: 0 auto;
    width: 90px;
    height: 90px;
  }
`

const Message = styled.p`
  ${typeStyle('-ds-font-title-2-regular')}
  margin: 0 auto 24px auto;
  max-width: 500px;
`

const ApologiesWrapper = styled.div`
  margin-top: 40px;

  & > * {
    margin: 0 auto;
  }
`

const Inner = styled.div`
  color: ${({ theme }) => theme['-ds-neutral-700'].value};
  text-align: center;
`

const Outer = styled.div`
  grid-column: 1 / -1;
  padding: 30px;
  margin: 0 auto;
`

type EmptyProps = {
  message?: ReactNode
  apologiesMessage?: {
    title: ReactNode
    body: ReactNode
  }
  actions?: ReactNode
}

const Empty = ({ message, apologiesMessage, actions }: EmptyProps) => {
  return (
    <Outer>
      <Inner>
        <IllustrationWrapper>
          <YogaDetailedIcon />
        </IllustrationWrapper>

        <Message>
          {message || (
            <>Uh-oh! We can&apos;t find anything that matches your search.</>
          )}
        </Message>

        {actions}

        {apologiesMessage && (
          <ApologiesWrapper>
            <WarningCard
              title={apologiesMessage.title}
              message={apologiesMessage.body}
            />
          </ApologiesWrapper>
        )}
      </Inner>
    </Outer>
  )
}

export default Empty
